import type { DefaultOptionType } from 'antd/es/select';

export const UNKNOWN_GENDER_ID = '';
export const FEMALE_ID = 'f';
export const MALE_ID = 'm';

export const UNKNOWN_LABEL = 'Неизвестно';
export const FEMALE_LABEL = 'Женский';
export const MALE_LABEL = 'Мужской';

export const GENDER: DefaultOptionType[] = [
  {
    label: <span data-testid="unknown-gender">{UNKNOWN_LABEL}</span>,
    value: UNKNOWN_GENDER_ID,
  },
  {
    label: <span data-testid="female-gender">{FEMALE_LABEL}</span>,
    value: FEMALE_ID,
  },
  {
    label: <span data-testid="male-gender">{MALE_LABEL}</span>,
    value: MALE_ID,
  },
];
